import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const BASE_URL = "https://newalemny.3almny.app/api";
export const checkCode = createAsyncThunk(
  'checkCode/checkCode',
  async (codeData, { rejectWithValue }) => {
    try {
      const response = await fetch(`${BASE_URL}/check_code`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token3almny')}`
        },
        body: JSON.stringify(codeData)
      });

      const data = await response.json();

      if (!response.ok) {
        return rejectWithValue(data);
      }

      return data;
    } catch (error) {
      return rejectWithValue({
        message: 'حدث خطأ في الاتصال بالخادم',
        statusCode: 500,
        status: 'failed'
      });
    }
  }
);

const initialState = {
  isChecking: false,
  checkError: null,
  checkSuccess: false,
  checkResult: null
};

const checkCodeSlice = createSlice({
  name: 'checkCode',
  initialState,
  reducers: {
    clearCheckError: (state) => {
      state.checkError = null;
    },
    clearCheckSuccess: (state) => {
      state.checkSuccess = false;
      state.checkResult = null;
    },
    resetCheckCode: (state) => {
      state.isChecking = false;
      state.checkError = null;
      state.checkSuccess = false;
      state.checkResult = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(checkCode.pending, (state) => {
        state.isChecking = true;
        state.checkError = null;
        state.checkSuccess = false;
      })
      .addCase(checkCode.fulfilled, (state, action) => {
        state.isChecking = false;
        state.checkSuccess = true;
        state.checkResult = action.payload;
        state.checkError = null;
      })
      .addCase(checkCode.rejected, (state, action) => {
        state.isChecking = false;
        state.checkError = action.payload;
        state.checkSuccess = false;
      });
  }
});

export const { clearCheckError, clearCheckSuccess, resetCheckCode } = checkCodeSlice.actions;

export default checkCodeSlice.reducer; 